import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_PRODUCT_CATALOG: MijnRoute = {
    path: 'product-catalog',
    navigationEvent: 'toProductCatalog',
    regex: /^\/zelf-regelen\/product-catalog$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/product-catalog'
};
